module.exports = __webpack_public_path__ + "img/solution_main.b845bd37.jpg";